import SimpleCalloutRepository from "../SimpleCalloutRepository"

export default class CompanySimpleCalloutRepository extends SimpleCalloutRepository {
    static schemaId = "company_simpleCallout"

    constructor() {
        super(CompanySimpleCalloutRepository.schemaId)
    }
}
